<template>
    <AutocompleteInput :modelValue="modelValue"
                       @update:modelValue="handleInput"
                       :options="options"
                       placeholder="Search for an Icon"
    >
        <template #option="optionProps">
            <Icon :icon="optionProps.option.value" class="mr-2" /> {{optionProps.option.label}}
        </template>
    </AutocompleteInput>
</template>

<script>
const iconOptions = [
  'apple-whole',
  'arrow-trend-up',
  'award',
  'baby',
  'battery',
  'bed',
  'bicycle',
  'bolt',
  'book-open',
  'brain',
  'briefcase',
  'bullseye',
  'bullseye-arrow',
  'calendar',
  'calendar-check',
  'calendar-day',
  'calendar-week',
  'camera',
  'chart-column',
  'chart-line',
  'check',
  'circle-check',
  'circle-plus',
  'clipboard-list',
  'cloud-arrow-up',
  'code',
  'cog',
  'dollar',
  'dumbbell',
  'eye',
  'fire',
  'fork-knife',
  'gauge-high',
  'heart',
  'heart-pulse',
  'house',
  'lightbulb',
  'list',
  'lock',
  'medal',
  'moon',
  'mountain',
  'person-running',
  'person-walking',
  'pills',
  'plate-utensils',
  'plus',
  'puzzle',
  'ring',
  'route',
  'scale-balanced',
  'scroll',
  'shield',
  'shoe-prints',
  'spa',
  'star',
  'stopwatch',
  'sun',
  'trophy',
  'user-circle',
  'utensils',
  'wand-magic-sparkles',
  'watch-fitness',
  'weight-hanging',
  'whistle',
];

export default {
  name: 'FontAwesomeIconInput',
  computed: {
    options() {
      return [
        ...new Set([
          this.modelValue,
          ...iconOptions,
        ].filter(Boolean)),
      ].map((icon) => {
        return {
          label: icon,
          value: icon,
        };
      });
    },
  },
  methods: {
    handleInput(value) {
      this.$emit('update:modelValue', value);
    },
  },
  props: {
    modelValue: {
      required: true,
    },
  },
}
</script>

<style lang="scss">

</style>
